import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

export default function ShowResults(props) {
  const classes = useStyles();

  {
    /*....................................................................|...............
  .............final value/object passed to confirmBooking component.....\|/..............
  ........................................................................V...............*/
  }
  const formTransition = () => {
    props.getFormValuesAfterPreview(props.values);
    props.triggerParentMethod();
  };
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom color="error">
        Please do confirm values, or go back to fill them again.
      </Typography>
      <Typography>Full Name: {props.values.fullName}</Typography>
      <Typography>Mobile Number: {props.values.phoneNo}</Typography>
      <Typography>Email id: {props.values.email}</Typography>
      <Typography>Gender: {props.values.gender}</Typography>
      <Typography gutterBottom>
        ID proof:{" "}
        <img style={{ width: "24%" }} src={props.values.idProof} alt=""></img>
      </Typography>
      {props.values.bookingType === "SELF" ? null : (
        <Typography>
          Are you a part of the registration:{" "}
          {props.values.bookingId === 0 ? "No" : "Yes"}
        </Typography>
      )}
      <Typography>Registration Type: {props.values.bookingType}</Typography>
      <Typography>Number of Tickets: {props.values.noOfPeople}</Typography>
      {props.values.detailsOfPeople.length > 1 ? (
        <Typography gutterBottom id="multipleRegistration">
          Group details: <br />
          <br />
          {props.values.detailsOfPeople.slice(1).map((member) => (
            <React.Fragment>
              <div>
                <TextField
                  disabled
                  variant="outlined"
                  margin="none"
                  style={{ width: "33%" }}
                  label="Full Name"
                  value={member.fullName}
                />
                <TextField
                  disabled
                  variant="outlined"
                  margin="none"
                  style={{ width: "33%" }}
                  label="Mobile Number"
                  value={member.phoneNo}
                />
                <TextField
                  disabled
                  variant="outlined"
                  margin="none"
                  style={{ width: "33%" }}
                  label="Gender"
                  value={member.gender}
                />
              </div>
              <br />
            </React.Fragment>
          ))}
        </Typography>
      ) : null}
      {/*.......................................................|...............
         .............button to go back to UserDetails.jsx.....\|/..............
         .......................................................V...............*/}
      <div className={classes.buttons}>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={props.triggerBackParentMethod}
        >
          Back
        </Button>
        {/*...........................................................|...............
         .............button to go forward to ConfirmBooking.jsx.....\|/..............
         .............................................................V...............*/}
        <Button
          variant="contained"
          color="primary"
          onClick={formTransition}
          className={classes.button}
        >
          Confirm
        </Button>
      </div>
    </React.Fragment>
  );
}
